export const SET_LIST_EVENTS = 'SET_LIST_EVENTS';
export const SET_VALIDATION_ERRORS_ADD_EXPERIMENT_TO_BATCH = 'SET_VALIDATION_ERRORS_ADD_EXPERIMENT_TO_BATCH';
export const SET_VALIDATION_WARNINGS_ADD_EXPERIMENT_TO_BATCH = 'SET_VALIDATION_WARNINGS_ADD_EXPERIMENT_TO_BATCH';
export const SET_POTENTIAL_BATCH_FOR_EXPERIMETN = 'SET_POTENTIAL_BATCH_FOR_EXPERIMETN';
